import axios from 'axios';
import { useEffect, useState } from 'react';
import { useApp } from '@/context/AppContext';
export const FINANCE_API = `${process.env.REACT_APP_BACKEND_URL}/api/finance`;
export const finance = {
  get: (path, params) => axios.get(`${FINANCE_API}${path}`, { params }).then(r => r.data),
  post: (path, body) => axios.post(`${FINANCE_API}${path}`, body).then(r => { window.dispatchEvent(new Event('finance-updated')); return r.data; }),
};
export const money = n => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 2 }).format((n || 0) / 100);
export const paise = value => Math.round(Number(value || 0) * 100);
export const label = s => (s || '').replaceAll('_', ' ');
export const errorText = e => {
  const d = e?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map(x => `${x.loc?.slice(1).join('.')}: ${x.msg}`).join('; ');
  return [d?.message, ...(d?.warnings || [])].filter(Boolean).join(' ') || e.message || 'Unable to complete this action';
};
export async function downloadReport(kind, params) {
  const { data } = await axios.get(`${FINANCE_API}/reports/${kind}`, { params, responseType: 'blob' });
  const url = URL.createObjectURL(data); const a = document.createElement('a');
  a.href = url; a.download = `nyayyaksha-${kind}.csv`; a.click(); URL.revokeObjectURL(url);
}


export function useFinanceTotals({ matterId, clientId } = {}) {
  const { scope } = useApp();
  const [totals, setTotals] = useState(null);
  useEffect(() => {
    let active = true;
    const load = () => {
      if (!['Managing Partner','Firm Admin','Senior Advocate','Advocate','Client'].includes(scope.role)) return;
      finance.get('/overview', { ...(matterId ? {matterId} : {}), ...(clientId ? {clientId} : {}) })
        .then(data => { if (active) setTotals(data.totals); }).catch(() => { if (active) setTotals(null); });
    };
    load(); window.addEventListener('finance-updated', load);
    return () => { active = false; window.removeEventListener('finance-updated', load); };
  }, [scope.role, matterId, clientId]);
  return totals;
}
